var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "padd" }, [
      _c("div", { staticClass: "osResFooter marTX" }, [
        _c("p", { staticClass: "fntH6 fntL marBS widL" }, [
          _c("strong", { staticClass: "regular" }, [_vm._v("알아두세요!")])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "osResNoticeList widL" }, [
          _c("ul", [
            _c("li", [
              _vm._v(
                "- 본 프로그램은 아티스트리의 새로운 메이크업 룩 3가지 중에서 1가지를 골라 아이&블러셔&립의 컬러 메이크업을 받아 보실 수 있는 프로그램으로 약 10~15분간 진행됩니다."
              )
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                "- 선택하신 메이크업 룩에 따라 아이 섀도우, 아이라이너, 마스카라, 아이 브로우, 블러셔, 쉐이딩 제품 중 필요한 제품이 사용됩니다."
              )
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v("- 스킨 케어 및 베이스 메이크업은 진행하지 않습니다.")
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                "- 베이스 메이크업을 사전에 진행하고 오셔도 무방합니다. 기존의 메이크업을 지워드리는 서비스는 제공하지 않습니다."
              )
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v("- 본 프로그램은 홈페이지 로그인 후 예약이 가능합니다.")
            ]),
            _vm._v(" "),
            _c("li", [_vm._v("- ID당 1개의 예약만 가능합니다.")]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                "- 예약의 확인, 취소는 예약 사이트에서만 6/4(일) 자정까지만 가능합니다. 이후 취소, 재 예약은 불가능합니다."
              )
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                "- 예약을 변경하실 경우 취소 후 재 예약만 가능합니다. 취소 후에는 예약 상황에 따라 재 예약이 어려우실 수 있습니다. 취소된 예약은 다른 고객이 먼저 예약하실 수 있습니다."
              )
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                "- 예약 시 선택한 메이크업 룩은 현장에서 다른 룩으로 변경하실 수 있습니다."
              )
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                "- 예약 시 선택한 ABC, 날짜, 시간대에 맞춰 방문하셔야 서비스 이용이 가능합니다. 예약한 시간보다 5분 이상 늦을 경우 예약이 자동 취소됩니다. 본인 확인 등 원활한 서비스 이용을 위해 예약 시간 5분 전에 도착하시는 것을 권장드립니다."
              )
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                "- 예약자가 동행하여 방문할 경우 다른 이용자에게 서비스 양도가 가능합니다. 이때 서비스는 1분만 받으실 수 있습니다."
              )
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                "- 온라인 예약을 하셨더라도 상황에 따라 대기가 발생할 수 있습니다."
              )
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v("- 온라인 예약 없이 방문 시 서비스를 받으실 수 없습니다.")
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                "- 최종 예약 확인 문자는 www.amway.co.kr에 등록된 번호로 발송됩니다. 예약 확정 전, 예약 문자 수신하실 번호 확인 부탁드립니다."
              )
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                "- ABC 방문 시, 서비스 예약 문자와 본인 확인이 진행될 수 있습니다."
              )
            ])
          ])
        ])
      ])
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6a0a2344", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6a0a2344","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/artistry/makeover/components/footer.vue
// module id = null
// module chunks = 